import { ProductProps, WbdItemProps } from "../interfaces/interfaces";

export function buildDesignPages(
  wbdDesign: WbdItemProps[],
  tallyDesign: ProductProps[],
  tol?: number | null,
): WbdItemProps[][] {
  const tolNum = tol ? +tol : null;
  const allWellboreArray: WbdItemProps[] = [];

  for (let j = 0; j < wbdDesign.length; j++) {
    const top = tallyDesign[j]?.top;
    const bottom = tallyDesign[j]?.bottom;
    const isTol = top && bottom && tolNum && top <= tolNum && bottom >= tolNum;
    let item = wbdDesign[j];

    if (item.tool.quantity === 1 && item.tool.id !== 0) {
      if (isTol) item = { ...item, tol: true };
      allWellboreArray.push(item);
    } else if (
      item.tool.quantity !== 1 &&
      item.tool.quantity !== 0 &&
      item.tool.id !== 0
    ) {
      const totalTools = Array.from(
        { length: item.tool.quantity },
        (_, index) => {
          const {
            tool: { length },
          } = item;
          if (isTol) {
            const temp = tolNum - top;
            const toolIndex = Math.floor(temp / length);
            if (toolIndex === index) {
              return { ...item, tol: true, isUnderTol: false };
            }
          }
          return { ...item, isUnderTol: false };
        },
      );
      allWellboreArray.push(...totalTools);
    }
  }

  let indexTol: number | null = null;
  for (let i = 0; i < allWellboreArray.length; i++) {
    if (allWellboreArray[i].tol) indexTol = i;
    allWellboreArray[i].isUnderTol = false;
    if (indexTol !== null && i > indexTol) allWellboreArray[i].isUnderTol = true;
  }

  const design: WbdItemProps[][] = [];
  const firstPageWbd: WbdItemProps[] = [];
  let sizeCountFirstPage = 0;
  let leftIndex = 0;

  for (let i = 0; i < allWellboreArray.length; i++) {
    sizeCountFirstPage += allWellboreArray[i].tool.size || 1;
    if (sizeCountFirstPage < 30) {
      firstPageWbd.push(allWellboreArray[i]);
      leftIndex += 1;
    }
  }
  design.push(firstPageWbd);

  const restAfterFirstPage = allWellboreArray.filter(
    (_, index) => index >= leftIndex,
  );
  if (restAfterFirstPage.length > 0) {
    const sizeLeft = restAfterFirstPage.reduce(
      (acc, curr) => acc + (curr.tool.size || 1),
      0,
    );
    const numberOfPages = Math.ceil(sizeLeft / 30);
    if (numberOfPages > 0) {
      let firstItem = 0;
      for (let x = 0; x < numberOfPages; x++) {
        const newPage: WbdItemProps[] = [];
        let sizeCount = 0;
        for (let i = firstItem; i < restAfterFirstPage.length; i++) {
          if (sizeCount < 35) {
            sizeCount += restAfterFirstPage[i].tool.size || 1;
            newPage.push(restAfterFirstPage[i]);
            firstItem++;
          }
        }
        if (newPage.length > 0) design.push(newPage);
      }
    } else {
      const newPage: WbdItemProps[] = [];
      let sizeCount = 0;
      for (let i = 0; i < restAfterFirstPage.length; i++) {
        sizeCount += restAfterFirstPage[i].tool.size || 1;
        if (sizeCount < 30) newPage.push(restAfterFirstPage[i]);
      }
      if (newPage.length > 0) design.push(newPage);
    }
  }

  return design;
}
